import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"
import _imports_0 from '@/assets/AgeWage-Icon.svg'


const _hoisted_1 = { class: "w-100 h-100 d-flex align-center justify-space-between overflow-y-hidden" }
const _hoisted_2 = { class: "content-title d-flex align-center" }
const _hoisted_3 = { class: "d-flex align-center jusity-space-between" }
const _hoisted_4 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_AppTable = _resolveComponent("AppTable")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_label = _resolveComponent("v-label")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_AppLoader = _resolveComponent("AppLoader")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!

  return (_openBlock(), _createBlock(_component_v_toolbar, {
    class: "dashboard-toolbar",
    height: "100",
    color: "transparent",
    flat: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_btn, {
            class: "ml-2 hamburger rounded-circle",
            onClick: _ctx.toggleDrawer,
            icon: "fa fa-bars",
            color: "#717073"
          }, null, 8, ["onClick"]),
          _createVNode(_component_v_toolbar_title, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.currentHeader.title), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_tooltip, {
            location: "end",
            "content-class": "tooltip-text",
            class: "content-title-tooltip"
          }, {
            activator: _withCtx(({ props }) => [
              _createVNode(_component_v_icon, _mergeProps({
                color: "rgba(140, 140, 140, 0.68)",
                small: ""
              }, props, { class: "d-block mt-1 ml-2" }), {
                default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                  _createTextVNode("fa fa-info-circle", -1)
                ]))]),
                _: 1
              }, 16)
            ]),
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_ctx.currentHeader.tooltip), 1)
            ]),
            _: 1
          })
        ]),
        _createVNode(_Transition, { name: "roller" }, {
          default: _withCtx(() => [
            (!_ctx.navDrawerIsVisible)
              ? (_openBlock(), _createBlock(_component_v_img, {
                  key: 0,
                  src: _imports_0,
                  class: "logo-icon"
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
          (_ctx.showUploadButton)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                size: "small",
                "data-testid": "UploadDataBtn",
                color: "success",
                variant: "flat",
                class: "upload-data-btn ml-2 mr-4 d-none d-md-block",
                onClick: _ctx.toggleDialog
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    left: "",
                    small: "",
                    class: "mr-2"
                  }, {
                    default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                      _createTextVNode("fa fa-plus", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[23] || (_cache[23] = _createElementVNode("span", null, "Upload", -1))
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.showUploadButton)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 1,
                size: "small",
                color: "success",
                variant: "flat",
                class: "upload-data-btn ml-2 mr-4 d-none d-md-block",
                onClick: _ctx.toggleProviderDialog
              }, {
                default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                  _createElementVNode("span", null, "Manage Master List", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.showUploadButton)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 2,
                class: "elevation-4 mr-3 pa-3",
                ripple: false,
                color: "primary",
                "data-testid": "ProfileBtn",
                variant: "text",
                to: "/users"
              }, {
                default: _withCtx(() => [
                  _cache[26] || (_cache[26] = _createTextVNode(" Manage Users", -1)),
                  _createVNode(_component_v_icon, {
                    small: "",
                    class: "px-2 ml-2"
                  }, {
                    default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                      _createTextVNode("fas fa-user-alt", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_menu, { location: "bottom" }, {
            activator: _withCtx(({ props }) => [
              _createVNode(_component_v_btn, _mergeProps({
                class: "profile-rectangle elevation-6 mr-3",
                ripple: false,
                "data-testid": "ProfileBtn",
                variant: "text"
              }, props), {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { small: "" }, {
                    default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                      _createTextVNode("fas fa-user-alt", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 16)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_list, {
                dense: "",
                "min-width": 200
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, null, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.user.name), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider),
                  _createVNode(_component_v_list_item, {
                    "data-testid": "changePassBtn",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showChangePasswordDialog = true))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                          _createTextVNode("Change Password", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider),
                  _createVNode(_component_v_list_item, {
                    "data-testid": "LogoutBtn",
                    onClick: _ctx.logout
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                          _createTextVNode("Log out", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_v_dialog, {
          modelValue: _ctx.showChangePasswordDialog,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showChangePasswordDialog) = $event)),
          width: "600px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { style: {"padding":"10px"} }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "text-h5" }, {
                  default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                    _createTextVNode("Please enter the passwords", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_divider),
                _cache[32] || (_cache[32] = _createElementVNode("br", null, null, -1)),
                _createVNode(_component_v_card_text, { class: "change-pass-form pb-6" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_form, {
                      modelValue: _ctx.validForm,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.validForm) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.oldPass,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.oldPass) = $event)),
                          label: "Old Password",
                          variant: "filled",
                          type: _ctx.show1 ? 'text' : 'password',
                          "append-inner-icon": _ctx.show1 ? 'fa fa-eye' : 'fa fa-eye-slash',
                          "onClick:appendInner": _cache[2] || (_cache[2] = ($event: any) => (_ctx.show1 = !_ctx.show1))
                        }, null, 8, ["modelValue", "type", "append-inner-icon"]),
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.newPass,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newPass) = $event)),
                          label: "New Password",
                          variant: "filled",
                          type: _ctx.show2 ? 'text' : 'password',
                          rules: [_ctx.rules.required, _ctx.rules.min, _ctx.rules.passRequireMents],
                          "append-inner-icon": _ctx.show2 ? 'fa fa-eye' : 'fa fa-eye-slash',
                          "onClick:appendInner": _cache[4] || (_cache[4] = ($event: any) => (_ctx.show2 = !_ctx.show2))
                        }, null, 8, ["modelValue", "type", "rules", "append-inner-icon"]),
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.newPassCheck,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newPassCheck) = $event)),
                          label: "Confirm New Password",
                          variant: "filled",
                          type: _ctx.show3 ? 'text' : 'password',
                          "append-inner-icon": _ctx.show3 ? 'fa fa-eye' : 'fa fa-eye-slash',
                          rules: [_ctx.rules.required, _ctx.rules.passMatch(_ctx.newPass, _ctx.newPassCheck)],
                          "onClick:appendInner": _cache[6] || (_cache[6] = ($event: any) => (_ctx.show3 = !_ctx.show3))
                        }, null, 8, ["modelValue", "type", "append-inner-icon", "rules"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_divider),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    (_ctx.changingPassword)
                      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                          key: 0,
                          size: 40,
                          color: "purple",
                          width: 4,
                          indeterminate: ""
                        }))
                      : (_openBlock(), _createBlock(_component_v_btn, {
                          key: 1,
                          class: "mx-auto",
                          color: "blue-darken-1",
                          variant: "text",
                          onClick: _ctx.changePassword
                        }, {
                          default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                            _createTextVNode("Change Password", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"]))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_v_dialog, {
          modelValue: _ctx.showProviderDialog,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.showProviderDialog) = $event)),
          "max-width": "80vw"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { class: "pa-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "d-flex align-center justify-space-between" }, {
                  default: _withCtx(() => [
                    _cache[36] || (_cache[36] = _createElementVNode("div", null, [
                      _createElementVNode("div", null, "AgeWage Master List")
                    ], -1)),
                    _createElementVNode("div", null, [
                      _createVNode(_component_v_btn, {
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.addProviderModal = true)),
                        size: "small",
                        variant: "outlined",
                        color: "primary",
                        class: "mr-6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            class: "mr-2",
                            size: "small",
                            left: ""
                          }, {
                            default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                              _createTextVNode("fas fa-plus", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[34] || (_cache[34] = _createElementVNode("span", null, "Add Provider", -1))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_btn, {
                        small: "",
                        density: "comfortable",
                        variant: "flat",
                        icon: "",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showProviderDialog = false))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            small: "",
                            color: "##0000008a"
                          }, {
                            default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                              _createTextVNode("fa fa-times", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_AppTable, {
                      "table-data": _ctx.providerTableData,
                      onRemoveItemClick: _cache[11] || (_cache[11] = (e) => _ctx.removeProvider(e)),
                      disablePagination: true
                    }, null, 8, ["table-data"])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_4, [
                  (_ctx.totalPage > 1)
                    ? (_openBlock(), _createBlock(_component_v_pagination, {
                        key: 0,
                        modelValue: _ctx.currPage,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.currPage) = $event)),
                        length: _ctx.totalPage,
                        "active-color": "primary",
                        "prev-icon": "fa fa-caret-left",
                        "next-icon": "fa fa-caret-right",
                        onNext: _cache[13] || (_cache[13] = ($event: any) => (_ctx.currPage + 1)),
                        density: "comfortable",
                        onPrevious: _cache[14] || (_cache[14] = ($event: any) => (_ctx.currPage - 1)),
                        "total-visible": 7
                      }, null, 8, ["modelValue", "length"]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      color: "grey-darken-1",
                      variant: "text",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showProviderDialog = false))
                    }, {
                      default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                        _createTextVNode("Close", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_v_dialog, {
          modelValue: _ctx.addProviderModal,
          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.addProviderModal) = $event)),
          persistent: "",
          "max-width": "30vw"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "d-flex align-center justify-space-between" }, {
                  default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                    _createElementVNode("span", { class: "text-h5" }, _toDisplayString('Add Provider'), -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_v_label, null, {
                        default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                          _createTextVNode("Select a Provider", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_v_autocomplete, {
                        "data-testid": "Upload-Provider-List",
                        modelValue: _ctx.selectedProvider,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.selectedProvider) = $event)),
                        loading: _ctx.fetchingProviders,
                        items: _ctx.filteredProviders,
                        "item-title": "name",
                        "item-value": "id",
                        class: "mx-0 mt-2",
                        type: "text",
                        "hide-no-data": "",
                        "hide-details": "",
                        label: "Provider",
                        variant: "filled"
                      }, null, 8, ["modelValue", "loading", "items"]),
                      _createVNode(_component_v_btn, {
                        block: "",
                        type: "submit",
                        color: !_ctx.selectedProvider || _ctx.addingProvider ? 'disabled' : 'success',
                        class: "mt-5",
                        loading: _ctx.addingProvider,
                        disabled: !_ctx.selectedProvider || _ctx.addingProvider,
                        onClick: _ctx.addProvider
                      }, {
                        default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                          _createTextVNode(" Add ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["color", "loading", "disabled", "onClick"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      color: "grey-darken-1",
                      variant: "text",
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.addProviderModal = false))
                    }, {
                      default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                        _createTextVNode("Close", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_v_snackbar, {
          modelValue: _ctx.snackbar.model,
          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.snackbar.model) = $event)),
          timeout: _ctx.snackbar.timeout,
          color: _ctx.snackbar.success ? 'green' : 'red',
          top: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.snackbar.text), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "timeout", "color"])
      ]),
      (_ctx.fetchingProviders || _ctx.removingProvider)
        ? (_openBlock(), _createBlock(_component_AppLoader, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}